exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".demo-table-expand label[data-v-a5ed9f5c]{width:90px}.el-dropdown-link[data-v-a5ed9f5c]{cursor:pointer;color:#1890ff;font-size:12px}.el-icon-arrow-down[data-v-a5ed9f5c]{font-size:12px}.icon-arrow-down[data-v-a5ed9f5c]  .el-dropdown-menu__item{font-size:12px}", ""]);

// exports
